import React, {createContext, useContext, useImperativeHandle, useState} from "react";
import {SkeletonView, SkeletonViewText} from "../Skeleton";


const LoadingContext: any = createContext({} as any);

export const PlaceholderLoadingContainer = React.forwardRef((props: any, ref) => {
    const [loading, setLoading] = useState(true);

    useImperativeHandle(ref, () => ({
        hide: () => {
            setLoading(false)
        },
        show: () => {
            setLoading(true)
        }
    }));

    return (
        <LoadingContext.Provider value={{loading, setLoading}}>
            {props.children}
        </LoadingContext.Provider>
    )
})

export const usePlaceholderLoading: any = () => useContext(LoadingContext);

export const DivPlaceholder = (props) => {
    const {loading} = usePlaceholderLoading();
    return !loading ? (
        <>{props.children}</>
    ) : (
        <SkeletonView {...props}/>
    )
}

export const TextPlaceholder = (props: any) => {
    const {loading} = usePlaceholderLoading();
    return !loading ? (
        <div style={props?.style} className={props?.className}>{props.children}</div>
    ) : (
        <SkeletonViewText {...props}/>
    )
}